import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { withRouter } from 'react-router-dom';

import { loginUser } from 'modules/auth';
import LoadingOverlay from 'components/LoadingOverlay';
import FieldError from 'components/FieldError';

class LoginPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    logining: PropTypes.bool.isRequired,
    loginedIn: PropTypes.bool.isRequired,
    token: PropTypes.string.isRequired,
    error: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: ''
    };
  }

  /**
   * Handle Form Submit
   */
  submitForm = (e) => {
    e.preventDefault();
    const { username, password } = this.state;
    const { dispatch } = this.props;

    dispatch(loginUser(username, password));
  };

  /**
   * Handle Input changes
   */
  onInputChanged = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  };

  render() {
    const { logining, errors } = this.props;
    const showLoading = logining ? 'show' : '';

    // Build Error Messages
    let errorObject = {};
    if (get(errors, 'data.data')) {
      if (get(errors, 'data.data.params')) {
        errorObject = {
          ...errors.data.data.params
        }
      } else {
        errorObject.global = errors.data.message;
      }
    }

    return (
      <div className="wrapper wrapper--short">
        <div className="main-content">
          <div className="grid">
            <div className="grid__item">
              <h2 className="block-title text-center mb-20 mt-30">Login</h2>
              <div className={`form-wrapper ${showLoading}`}>
                <form className="login" onSubmit={this.submitForm}>
                  { errorObject.global && <div className="mb-30"><FieldError text={errorObject.global} /></div> }

                  <div className="form-row form-row-wide">
                    <label className="form-label" htmlFor="username">Username / Email <span className="required">*</span></label>
                    <input
                      type="text"
                      className="form-field form-field--text form-field--full"
                      name="username" 
                      id="username"
                      value={this.state.username}
                      onChange={this.onInputChanged}
                    />
                    { errorObject.username && <FieldError text={errorObject.username} /> }
                  </div>

                  <div className="form-row form-row-wide">
                    <label className="form-label" htmlFor="password">Password <span className="required">*</span></label>
                    <input
                      type="password"
                      className="form-field form-field--text form-field--full"
                      name="password"
                      id="password"
                      value={this.state.password}
                      onChange={this.onInputChanged}
                    />
                    { errorObject.password && <FieldError text={errorObject.password} /> }
                  </div>

                  <div className="form-row text-align-center">
                    <input
                      onClick={this.submitForm}
                      type="submit"
                      className="button button--primary button--uppercase button--wide"
                      name="login"
                      value="Log In"
                    />
                  </div>
                </form>
                <LoadingOverlay />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
    const {
        logining,
        loginedIn,
        token,
        error,
        errors
    } = state.auth;

    return {
        logining,
        loginedIn,
        token,
        error,
        errors
    };
}

export default withRouter(connect(mapStateToProps)(LoginPage));



// WEBPACK FOOTER //
// ./src/pages/Login/index.js